module.exports = __webpack_public_path__ + "static/media/scrim_command.315ec95b.webm";